import { useCategoryContext } from "@components/Components/Providers/CategoryContext";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import dynamic from "next/dynamic";
const MenuItem = dynamic(() => import("@mui/material/MenuItem"), {
    ssr: false
});


const CategorySortSelect = () => {
    
    const {
        category_sort, handleCategorySortChange
    } = useCategoryContext();

    return (
        <FormControl fullWidth>
            <InputLabel id="category-sort-label">Sort</InputLabel>
            <Select
                sx={{
                    width: {
                        xs: '100%',
                        lg: '50%'
                    },
                    maxWidth: {
                        xs: 'auto',
                        lg: '160px'
                    }
                }}
                labelId="category-sort-label"
                id="category-sort"
                label="Sort"
                value={category_sort}
                onChange={handleCategorySortChange}
            >
                <MenuItem value={"product_order"}>Best Match</MenuItem>
                <MenuItem value={"newest"}>Newly Listed</MenuItem>
                <MenuItem value={"price_asc"}>Price: Low - High</MenuItem>
                <MenuItem value={"price_desc"}>Price: High - Low</MenuItem>
                <MenuItem value={"name_asc"}>Name: A - Z</MenuItem>
                <MenuItem value={"name_desc"}>Price: Z - A</MenuItem>
            </Select>
        </FormControl>
    );
};

export default CategorySortSelect;
